import { i as d, x as p, s as m } from "../../../lit-element-6iugfgmM.js";
import { e as b } from "../../../custom-element-wk-AooBb.js";
import { n as c } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-button-fa52iiKJ.js";
import "../../../sp-dialog-C9swJ4nV.js";
import { Localize as y } from "../../../lib/I18N.js";
const u = { "duplicate-library-element-dialog.body": "These fonts are already saved to the library {libraryName}.", "duplicate-library-element-dialog.button": "OK", "duplicate-library-element-dialog.heading": "Already saved in library" }, g = d`p{text-align:left}`;
var h = Object.defineProperty, f = Object.getOwnPropertyDescriptor, s = (n, e, i, r) => {
  for (var l, t = r > 1 ? void 0 : r ? f(e, i) : e, o = n.length - 1; o >= 0; o--) (l = n[o]) && (t = (r ? l(e, i, t) : l(t)) || t);
  return r && t && h(e, i, t), t;
};
let a = class extends y(m, u) {
  constructor() {
    super(...arguments), this.libraryName = "";
  }
  static get styles() {
    return [g];
  }
  render() {
    return p`<sp-dialog size="m" variant="information"><h2 slot="heading">${this.t("duplicate-library-element-dialog.heading")}</h2><p>${this.t("duplicate-library-element-dialog.body", { libraryName: this.libraryName })}</p><sp-button variant="primary" treatment="outline" slot="button" @click="${this._handleCloseButtonClick}">${this.t("duplicate-library-element-dialog.button")}</sp-button></sp-dialog>`;
  }
  _handleCloseButtonClick() {
    this.dispatchEvent(new Event("close", { bubbles: !0, composed: !0 }));
  }
};
s([c({ type: String })], a.prototype, "libraryName", 2), a = s([b("af-duplicate-library-element-dialog")], a);
const j = a;
export {
  j as default
};
//# sourceMappingURL=DuplicateLibraryElementDialog.js.map
